import { Link, useNavigate } from 'react-router-dom';
import AffairConversionWizard from './AffairConversionWizard';

const getRealizationType = (item = {}) => item.realizationType || item.realization_type || 'project';
const getRealizations = (affair = {}) => affair.realizations || [
  ...(affair.projects || affair.Projects || []),
  ...(affair.interventions || affair.Interventions || []),
];
const realizationLink = (item) => getRealizationType(item) === 'intervention'
  ? `/Interventions/${item.id}`
  : `/projets/${item.id}`;
const realizationLabel = (item) => getRealizationType(item) === 'intervention' ? 'Intervention' : 'Projet';

export default function AffairProjectPanel({ affair }) {
  const navigate = useNavigate();
  const realizations = getRealizations(affair);

  if (realizations.length) {
    return (
      <section className="affair-panel">
        <div className="affair-panel__header">
          <div>
            <h2>Réalisation créée</h2>
            <p>L’affaire reste le dossier permanent ; sa réalisation est pilotée depuis l’espace ci-dessous.</p>
          </div>
        </div>
        {realizations.map((item) => (
          <article className="affair-project-link" key={`${getRealizationType(item)}-${item.id}`}>
            <div>
              <strong>{item.code || `${realizationLabel(item)} ${item.id}`}</strong>
              <span>{item.name || item.label || affair.name}</span>
            </div>
            <Link className="basic-button active" to={realizationLink(item)}>
              Ouvrir {getRealizationType(item) === 'intervention' ? 'l’intervention' : 'le projet'}
            </Link>
          </article>
        ))}
      </section>
    );
  }

  return (
    <AffairConversionWizard
      affair={affair}
      onConverted={(result) => navigate(result.targetType === 'intervention'
        ? `/Interventions/${result.intervention.id}`
        : `/projets/${result.project.id}`)}
    />
  );
}
